import React from "react";
import CountUp from "react-countup";
import AnimatedSection from "./AnimatedSection";

const stats = [
  {
    value: 500,
    suffix: "+",
    label: "Projects Delivered",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    value: 100,
    suffix: "+",
    label: "Happy Clients",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 20c0-4 3.5-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    value: 10,
    suffix: "+",
    label: "Years Experience",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    value: 24,
    suffix: "/7",
    label: "Support",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3v3M12 18v3M3 12h3M18 12h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
];

const WdevStats: React.FC = () => {
  return (
    <section className="wdev-stats" aria-label="Company statistics">
      <div className="container">
        <AnimatedSection>
          <div className="wdev-stats__grid">
            {stats.map((stat) => (
              <div className="wdev-stat-card" key={stat.label}>
                <div className="wdev-stat-card__icon">{stat.icon}</div>
                <div className="wdev-stat-card__content">
                  <div className="wdev-stat-card__value">
                    <CountUp end={stat.value} enableScrollSpy scrollSpyOnce />
                    <span>{stat.suffix}</span>
                  </div>
                  <p className="wdev-stat-card__label">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default WdevStats;
